import { Button } from "@mui/material";
import DashCard from "./DashCard";
import NoListItems from "../../Custom/NoListItems";
import { useNavigate } from "react-router-dom";

const getGradeColor = (grade) => {
  if (grade < 65) return "var(--red)";
  if (grade < 80) return "var(--gold)";
  return "var(--green)";
};

export const ListItem = ({ label, value, isValueGrade = false }) => {
  return (
    <li key={`metric-${label}`}>
      <small className="ellipsis">{label}</small>
      <small
        style={{ color: isValueGrade ? getGradeColor(value) : "var(--text)" }}
      >
        {value}
        {isValueGrade && "%"}
      </small>
    </li>
  );
};

const ExamMetrics = ({ metrics }) => {
  const navigate = useNavigate();
  function handleExamReportClick() {
    navigate(`/report/${metrics.id}`);
  }
  return (
    <DashCard
      title="Recent Exam Metrics"
      cornerContent={
        metrics && (
          <Button
            variant="contained"
            color="ghostGreen"
            className="px-4 py-1"
            disableElevation
            disabled={Boolean(!metrics?.id)}
            onClick={handleExamReportClick}
          >
            View Report
          </Button>
        )
      }
      children={
        !metrics ? (
          <NoListItems text="No metrics available" />
        ) : (
          <ul className="metrics">
            <ListItem
              label="Total Score"
              value={Math.round(metrics.score_percentage)}
              isValueGrade={true}
            />
            <ListItem
              label="Correct Questions"
              value={`${metrics.total_correct} / ${metrics.total_questions}`}
            />
            <ListItem
              label="Revealed Answers"
              value={metrics.revealed_answers}
            />
          </ul>
        )
      }
    />
  );
};

export default ExamMetrics;
